module.exports = __webpack_public_path__ + "static/media/save-money-icon.bee8fcb8.svg";